import React__default from 'react';
import classNames from 'classnames';
import InfoCircle from '../assets/icons/InfoCircle.esm.js';
import NvTooltip from '../NvTooltip/NvTooltip.esm.js';

var NvLabel = function (_a) {
    var className = _a.className, htmlFor = _a.htmlFor, isHidden = _a.isHidden, value = _a.value, tooltipText = _a.tooltipText, required = _a.required, isFormLabel = _a.isFormLabel;
    if (isHidden)
        return null;
    return (React__default.createElement("label", { className: classNames('nv-label', { 'nv-form-label': isFormLabel }, className), htmlFor: htmlFor },
        value,
        required && React__default.createElement("span", { className: "nv-text-red" }, "*"),
        tooltipText && (React__default.createElement(NvTooltip, { hasChildrenWrapper: false, text: tooltipText },
            React__default.createElement("span", null,
                React__default.createElement(InfoCircle, null))))));
};

export { NvLabel as default };
//# sourceMappingURL=NvLabel.esm.js.map
